import { render, staticRenderFns } from "./TradesChart.vue?vue&type=template&id=1580fa05"
import script from "./TradesChart.vue?vue&type=script&lang=js"
export * from "./TradesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports